import React from 'react';
import { BrowserRouter as Router, Route } from 'react-router-dom';
import RouteListener from './RouteListener';
import AssetListSlat from './AssetListSlat';

require('../../css/components/AssetList.scss');

'use strict';

export default class AssetList extends React.Component {
    constructor(props) {
        super(props);
        this.state = { assets: props.assets, loaded: props.assets, loading: false };
    }

    componentDidMount() {
        if (!this.state.loaded)
            this.loadData();
        else
            this.findNextAsset(this.props.location, this.state.assets);
    }

    componentDidUpdate() {
        this.findNextAsset(this.props.location, this.state.assets);
    }

    findNextAsset(location, assets) {
        if (!location || !assets)
            return;

        var asset = null;
        var nextAsset = null;

        for (var i = 2; i < assets.length + 1; i++)
            if (this.props.location.pathname === assets[i - 2].url) {
                asset = assets[i - 2];
                nextAsset = assets[i - 1];
                break;
            }

        if (nextAsset === null) {
            asset = assets[i-1];
            nextAsset = assets[0];
        }

        if (this.props.onNewCurrentAsset) {
            this.props.onNewCurrentAsset(this.props.location, asset, nextAsset);
        }
    }

    loadData() {
        fetch(this.props.apiUrl)
            .then(res => res.json())
            .then(
                (result) => {
                    if (this.props.onAssetsLoaded)
                        this.props.onAssetsLoaded(result);

                    this.setState({
                        loading: false,
                        loaded: true,
                        assets: result.assets
                    });
                },
                () => {
                    this.setState({
                        loading: false,
                        loaded: false
                    });
                }
            );
    }

    renderAssets() {
        if (this.state.loading)
            return 'Loading...';

        if (this.state.loaded) {
            var children = [];

            if (this.props.useRouter)
                children.push(
                    React.createElement(
                        Route,
                        {
                            key: '0',
                            path: '/',
                            component: RouteListener
                        },
                    )
                );

            children.push(this.state.assets.map(asset => {
                return React.createElement(
                    AssetListSlat,
                    {
                        key: asset.asset.keyID,
                        asset: asset,
                        useRouter: this.props.useRouter,
                        location: this.props.location,
                        urlHash: this.props.location.hash
                    }
                );
            }));

            var ul = React.createElement(
                'ul',
                {
                    className: 'assetList'
                },
                children
            );

            if (this.props.useRouter)
                return React.createElement(
                    Router,
                    { },
                    ul
                );
            else
                return ul;
        }
    }

    render() {
        return React.createElement(
            'div',
            {},
            [
                React.createElement(
                    'h2',
                    { key: "h" },
                    this.props.heading
                    ),
                this.renderAssets()
            ]
        );
    }
}